import apiClient from '@/api/client';

export const PartnerFirmwareVersionService = {
    async getAll(): Promise<PartnerFirmwareVersionResponse> {
        const response = await apiClient.get<PartnerFirmwareVersionResponse>('/partner/firmware-versions');
        const result = response.data

        if (response.status != 200) {
            throw new Error('Failed to retrieve firmware versions.');
        }

        return result;
      }
}

export interface PartnerFirmwareVersionResponse {
    versions: string[]
}